/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import styled from "styled-components";

import {WealthyEnv} from "helpers";
import {
  AppDownload
} from "./components";

const closeIcon = `url(${WealthyEnv.BROKING_CDN_URL}/close-icon-filled.png)`;

const GetStartedAppModal = ({
  toggleModal,
  setToggleModal
}) => {
  return (
    <ModalOverlay className={toggleModal ? "toggled" : ""}>
      <ModalContent>
        <CloseButton onClick={() => setToggleModal(!toggleModal)} />
        <AppDownload />
      </ModalContent>
    </ModalOverlay>
  );
};

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0s linear 0.3s;
  z-index: 10;

  &.toggled {
    opacity: 1;
    visibility: visible;
    transition: opacity 0.3s ease;

    & > div {
      animation: slideDown 0.3s ease;
      
      @keyframes slideDown {
        0% {
          transform: translateY(-100%);
        }
        100% {
          transform: translateY(0);
        }
      }
    }
  }
`;

const ModalContent = styled.div`
  background-color: #fff;
  border-radius: 5px;
  width: 415px;
  border-radius: 0.5rem;
  overflow: hidden;
  position: relative;
  display: flex;

  @media (max-width: 768px) {
    margin-left: 2rem;
    margin-right: 2rem;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 25px;
  right: 25px;
  height: 26px;
  width: 26px;
  border-radius: 100%;
  border: 0;
  outline: 0;
  background-image: ${closeIcon};
  background-size: contain;
  cursor: pointer;
`;

export default GetStartedAppModal;
